export const PUBLIC_ORIGIN = 'https://www.capcut.net';
/** debug平台、tcs、bpo平台的路由拼接规则和展示内容稍有不同，先提前按照不同文件夹划分，避免后期内容杂糅 */
export const PATH = {
  base: '/imlv/search',
  // detail: '/detail',
  bpoBase: '/imlv/bpo-search',
  bpoDetail: '/imlv/bpo-search-detail',
  tcsBase: '/imlv/tcs-search',
  tcsDetail: '/imlv/tcs-search-detail',
};

export const CCORIGIN = 'https://www.capcut.net/sharevideo';

export const TEMPLATE_INCOME_RECORD = 'https://www.capcut.net/imlv/income-records';

// 数据中心-数据口径说明
export const DATA_CENTER_DESCRIPTION_URL =
  'https://sf16-draftcdn-sg.ibytedtos.com/obj/ies-hotsoon-draft-sg/capcut/via_data_center_desc.html';
